"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.remove = exports.changeSnackbar = exports.showSnackbar = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = require("react-dom");

var _SnackbarWrapper = _interopRequireDefault(require("./SnackbarWrapper"));

var el = document.createElement('div');
document.body.appendChild(el);

var _render = (0, _reactDom.render)(_react.default.createElement(_SnackbarWrapper.default, null), el),
    showSnackbar = _render.showSnackbar,
    changeSnackbar = _render.changeSnackbar,
    remove = _render.remove;

exports.remove = remove;
exports.changeSnackbar = changeSnackbar;
exports.showSnackbar = showSnackbar;